import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material'
import { Security } from '@mui/icons-material'
import AuditorAssignmentForm from './AuditorAssignmentForm'

/**
 * Dialog wrapper around the shared AuditorAssignmentForm, used by the Service-Approvals
 * Auditor tab for assign (with practitioner search) and edit (existingProfile).
 */
export default function AuditorAssignmentDialog({
  open,
  onClose,
  onSuccess,
  fixedPractitioner = null,
  existingProfile = null,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Security />
          {existingProfile ? 'Edit Auditor Settings' : 'Assign Auditor Role'}
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <AuditorAssignmentForm
          fixedPractitioner={fixedPractitioner}
          existingProfile={existingProfile}
          searchEnabled={!fixedPractitioner && !existingProfile}
          onSuccess={() => {
            onSuccess?.()
            onClose?.()
          }}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  )
}
